// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { ClientsService } from '@coa/app/core/services/clients.service';
import { map } from 'rxjs/operators';
import { ClientDateAggregationType, DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DateAggregationService {

  constructor(
    private clientService: ClientsService,
  ) {
  }

  getDefaultType(clientId: string): Observable<DateRangeFilter> {
    return this.getAggregationTypes(clientId).pipe(
      map((client) => {
        if (client === ClientDateAggregationType.MONTHLY) {
          return DateRangeFilter.LAST_THREE_MONTHS;
        }
        if (client === ClientDateAggregationType.WEEKLY) {
          return DateRangeFilter.FOUR_WEEKS;
        }
        return DateRangeFilter.FOUR_WEEKS;
      }),
    );
  }

  getAggregationTypes(clientId: string): Observable<ClientDateAggregationType> {
    return this.clientService.getClients().pipe(
      map((clients) => clients.content),
      map((clients) => clients?.find((client) => client.id.toString() === clientId.toString())),
      map((client) => client?.defaultAnalyticsDateAggregate),
    );
  }
}
